import styled from 'styled-components';

import {ellipsis, flexCenter} from '../../../../../../../../libs/shared/ui/src/styles/mixins';

export const StyledMacroInputDropdownValueDiv = styled.div`
  display: flex;
  align-items: center;
  white-space: nowrap;
`;

export const StyledMacroInputDropdownIconDiv = styled.div`
  flex-shrink: 0;
  margin-right: 5px;
  color: ${(p) => p.theme.greys.shade70};
`;

export const StyledMacroInputDropdownNameDiv = styled.div`
  ${ellipsis()};
`;

export const StyledMacroInputDropdownPlaceholderDiv = styled.div`
  color: ${({theme}) => theme.composerPlaceholder};
  ${ellipsis()};
  ${flexCenter}
  gap: 8px;
`;

export const StyledMacroInputDescriptionDiv = styled.div`
  ${ellipsis(false)};
  word-wrap: break-word;
`;
